import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=58b1c4cf&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b1c4cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b1c4cf')) {
      api.createRecord('58b1c4cf', component.options)
    } else {
      api.reload('58b1c4cf', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=58b1c4cf&scoped=true&", function () {
      api.rerender('58b1c4cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OtNfxgsEp0LL/JS/comp/SearchFilterTokens.vue"
export default component.exports